import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../actions/api";

const slice = createSlice({
  name: "comprehensiveCarePlan",
  initialState: {
    ComprehensiveCareList: [],
    total: 0,
    currentPage: 1,
    toPage: null,
    lastPage: null,
    loading: false,
  },
  reducers: {
    fetchedComprehensiveCareSuccess: (enrollee, action) => {
      enrollee.loading = false;
      enrollee.ComprehensiveCareList = Array.isArray(action.payload)
        ? action.payload
        : action.payload.data || [];
      enrollee.total = Array.isArray(action.payload)
        ? action.payload.length
        : action.payload.meta?.total || 0;
      enrollee.currentPage = action.payload.meta?.from || 1;
      enrollee.toPage = action.payload.meta?.to || action.payload.length || 10;
      enrollee.lastPage = action.payload.meta?.last_page || 1;
    },
    fetchedComprehensiveCareStart: (enrollee, action) => {
      enrollee.loading = true;
    },
    fetchedComprehensiveCareFailed: (enrollee, action) => {
      enrollee.loading = false;
    },
  },
});

const {
  fetchedComprehensiveCareSuccess,
  fetchedComprehensiveCareStart,
  fetchedComprehensiveCareFailed,
} = slice.actions;

export default slice.reducer;

const url = "/v1/admin/comprehensive-checks";

export const fetchComprehensiveCares = (pageItems, page) =>
  apiCallBegan({
    url: `${url}?page_items=${pageItems}&page=${page}`,
    method: "GET",
    onSuccess: fetchedComprehensiveCareSuccess.type,
    onStart: fetchedComprehensiveCareStart.type,
    onError: fetchedComprehensiveCareFailed.type,
  });

export const getComprehensiveCares = (state) =>
  state.entities.enrolleeComprehensiveCares;
